// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"e1f0d4f3","346":"e1f0d4f3","459":"aac3e15c","465":"e203a755"}[chunkId] + ".chunk.css";
};